import React from "react";
import { HomeAboutUsData } from "../../helperFunction";
import { Row, Col, Button } from "antd";
import "./styles.scss";
const HomeAbout = ({ isGamePage }) => {
  return (
    <section
      className={`home-about-us-container ${
        isGamePage ? "game-about-us-container" : ""
      }`}
    >
      <div className="section-title-text">Press about us</div>
      <div className="section-title-desc">
        Breaking news about the stuff we do
      </div>
      <Row gutter={[24, 24]} className="home-about-us-content">
        {HomeAboutUsData?.map((e) => {
          return (
            <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
              <div className="date-text">{e?.date}</div>
              <div className="desc-text">{e?.desc}</div>
              <div className="extra-text">{e?.extra}</div>
            </Col>
          );
        })}
      </Row>
      {!isGamePage && (
        <Button className="more-games-btn" href="/news">
          Read Latest News
        </Button>
      )}
    </section>
  );
};

export default HomeAbout;
